// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__kfhtd","item":"styles_item__Z+nxZ","number":"styles_number__trhdk","button":"styles_button__Fa9FI","viewportMini":"styles_viewportMini__M9AHM"};